import { FormControl, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { handleRegionClick } from '../map-actions';

export const provMap = [
	{ val: 'p1', text: 'Province I' },
	{ val: 'p2', text: 'Province II' },
	{ val: 'p3', text: 'Province III' },
	{ val: 'p4', text: 'Province IV' },
	{ val: 'p5', text: 'Province V' },
	{ val: 'p6', text: 'Province VI' },
	{ val: 'p7', text: 'Province VII' },
	{ val: 'p8', text: 'Province VIII' },
];

export function ProvinceDropdown() {

	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);
	const [value, setValue] = useState('');
	const dispatch = useDispatch();
	const handleChange = (evt) => {
		const svg = document.getElementById('domestic-svg');
		const regions: ChildNode[] = [];
		let region = null;
		svg.childNodes.forEach(a => {
			if (a.nodeName === 'g') {
				regions.push(a);
				if ((a as HTMLElement)?.getAttribute('prov') === evt?.target?.value) region = a;
			}
		});

		handleRegionClick(region as HTMLElement, regions as HTMLElement[], svg, dispatch);
		setValue(evt?.target?.value);

	};

	return (
		<FormControl >
			<Select
				value={value}
				onChange={handleChange}
				displayEmpty
				renderValue={(selected: any) => {
					if (!selected || selected?.length === 0) {
						return <em>{settings?.provinceLabel}</em>;
					}
					const link = provMap?.filter(a => a.val === selected);
					return link[0]?.text;
				}}
			>
				{
					provMap?.map(a => <MenuItem key={a.val} value={a.val}>{a.text}</MenuItem>)
				}

			</Select>
		</FormControl>
	);
}